import React from 'react';
import './style.scss';
import AsyncSelect from 'react-select/async';
import { GroupBase, OptionsOrGroups, PropsValue } from 'react-select';
import useReactSelect from './customSelectStyle';
import { ControlSearchIcon } from './default';

interface Props {
    id: string;
    className?: string;
    label?: string;
    isInvalid?: boolean;
    errorMsg?: string;
    placeholder?: string;
    isDisabled?: boolean;
    onBlur?: React.FocusEventHandler<HTMLInputElement> | undefined;
    selectedValue: PropsValue<any>;
    isSearchable? : boolean;
    // eslint-disable-next-line no-unused-vars
    onChangeSelected: (e: {value: string | number, label: string}) => void;
    inputValue: string;
    // eslint-disable-next-line no-unused-vars
    onChangeInput: (e: string) => void;
    // eslint-disable-next-line no-unused-vars
    optionsFetcher: (text: string, callback: (options: OptionsOrGroups<{value: any, label: string}, GroupBase<{value: string, label: string}>>) => void) => void
}

const AsyncMode:React.FC<Props> = (props) => {
  const {
    errorMsg, selectedValue, onChangeSelected, inputValue, onChangeInput,
    id, className, label, isInvalid, optionsFetcher, onBlur, placeholder,
    isDisabled = false, isSearchable,
  } = props;
  const { customStyle } = useReactSelect(isInvalid ?? false);
  return (
    <div className={`d-flex flex-column w-100 position-relative ${className}`}>
      <label htmlFor={id} className={label ? 'label' : 'd-none'}>{label}</label>
      <AsyncSelect
        loadOptions={optionsFetcher}
        inputValue={inputValue}
        getOptionLabel={(e: any) => e.label}
        getOptionValue={(e: any) => e.value}
        onInputChange={onChangeInput}
        onChange={(e) => {
          if (e) onChangeSelected(e);
        }}
        cacheOptions
        defaultOptions
        value={selectedValue}
        styles={customStyle}
        onBlur={onBlur}
        isSearchable={isSearchable}
        components={{
          IndicatorSeparator: () => null,
          Control: ControlSearchIcon,
        }}
        placeholder={placeholder}
        isDisabled={isDisabled}
      />
      <div
        className={isInvalid ? 'invalidMsg' : 'd-none'}
      >
        {errorMsg}
      </div>
    </div>
  );
};

export default AsyncMode;
